import { OktaAuth } from '@okta/okta-auth-js';

const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER;
const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const OKTA_REDIRECT_URI = process.env.REACT_APP_OKTA_REDIRECT_URI || `${window.location.origin}/login/callback`;
const OKTA_POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_OKTA_POST_LOGOUT_REDIRECT_URI || window.location.origin;

if (!OKTA_ISSUER || !OKTA_CLIENT_ID) {
  throw new Error(
    'Missing Okta configuration. Please set REACT_APP_OKTA_ISSUER and REACT_APP_OKTA_CLIENT_ID in your .env file. See OKTA_SETUP.md for setup instructions.'
  );
}

export const CUSTOM_SCOPE = 'cd-dashboard.read';

// The org authorization server rejects unknown custom scopes, so only request
// ours from a custom authorization server (https://<org>/oauth2/<serverId>).
export function scopesForIssuer(issuer: string): string[] {
  const scopes = ['openid', 'profile', 'email'];
  return issuer.includes('/oauth2/') ? [...scopes, CUSTOM_SCOPE] : scopes;
}

export const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENT_ID,
  redirectUri: OKTA_REDIRECT_URI,
  postLogoutRedirectUri: OKTA_POST_LOGOUT_REDIRECT_URI,
  scopes: scopesForIssuer(OKTA_ISSUER),
  pkce: true,
  tokenManager: {
    autoRenew: true,
  },
});
